import script from "./TreeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeSelect.vue?vue&type=script&setup=true&lang=js"

import "./TreeSelect.vue?vue&type=style&index=0&id=727a7634&lang=scss"

const __exports__ = script;

export default __exports__